import { StyleSheet } from 'react-native-unistyles';

// Visually hidden but still read by assistive technology.
export const styles = StyleSheet.create({
  hidden: {
    position: 'absolute',
    width: 1,
    height: 1,
    overflow: 'hidden',
    opacity: 0,
  },
});
